import { render, staticRenderFns } from "./SlingCanvas.vue?vue&type=template&id=3e5f2b8c&scoped=true&"
import script from "./SlingCanvas.vue?vue&type=script&lang=ts&"
export * from "./SlingCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./SlingCanvas.vue?vue&type=style&index=0&id=3e5f2b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5f2b8c",
  null
  
)

export default component.exports